// Role action types
export const FETCH_ROLES_REQUEST = 'roles/FETCH_ROLES_REQUEST';
export const FETCH_ROLES_SUCCESS = 'roles/FETCH_ROLES_SUCCESS';
export const FETCH_ROLES_FAILURE = 'roles/FETCH_ROLES_FAILURE';
export const ADD_ROLE_SUCCESS = 'roles/ADD_ROLE_SUCCESS';
export const UPDATE_ROLE_SUCCESS = 'roles/UPDATE_ROLE_SUCCESS';
export const DELETE_ROLE_SUCCESS = 'roles/DELETE_ROLE_SUCCESS';
export const SET_EDITING_ROLE = 'roles/SET_EDITING_ROLE';
export const CLEAR_EDITING_ROLE = 'roles/CLEAR_EDITING_ROLE';
